var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row" }, [
    _vm.elHelp.length > 0 && !_vm.readonly
      ? _c("i", {
          staticClass: "fa fa-question pull-right",
          attrs: {
            "aria-expanded": !_vm.triggerShowHelp,
            "aria-controls": "help-" + (_vm.elName || _vm.elId)
          },
          on: {
            click: function($event) {
              _vm.triggerShowHelp = !_vm.triggerShowHelp
            }
          }
        })
      : _vm._e(),
    _c("label", { staticClass: "form-label", attrs: { for: _vm.elId } }, [
      _vm._v(" " + _vm._s(_vm.titleWithLanguage) + " ")
    ]),
    _c("div", { staticClass: "input-group col-12" }, [
      _vm.hasPrefix
        ? _c("div", { staticClass: "input-group-addon" }, [
            _vm._v(" " + _vm._s(_vm.elOptions.inputGroup.prefix))
          ])
        : _vm._e(),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.curValue,
            expression: "curValue"
          }
        ],
        class: _vm.getClasses,
        attrs: {
          type: "text",
          pattern: _vm.elOptions.elInputPattern,
          name: _vm.elName || _vm.elId,
          id: _vm.elId,
          readonly: _vm.readonly
        },
        domProps: { value: _vm.curValue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.curValue = $event.target.value
          }
        }
      }),
      _vm.hasSuffix
        ? _c("div", { staticClass: "input-group-addon" }, [
            _vm._v(" " + _vm._s(_vm.elOptions.inputGroup.suffix))
          ])
        : _vm._e()
    ]),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showHelp,
          expression: "showHelp"
        }
      ],
      staticClass: "question-option-help well",
      attrs: { id: "help-" + (_vm.elName || _vm.elId) },
      domProps: { innerHTML: _vm._s(_vm.elHelp) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }